export const projects = [
  {
    slug: "espamanager",
    name: "ESPAMANAGER.GR",
    url: "https://espamanager.gr",
    img: "/projects/espamanager.jpg",
    filter: "webapps",
    category: { gr: "WEB APPLICATION", en: "WEB APPLICATION" },
    desc: {
      gr: "Web application για τη διαχείριση αιτήσεων χρηματοδότησης — ΕΣΠΑ, ΟΑΕΔ και Αναπτυξιακός Νόμος — με αυτόματο έλεγχο δικαιολογητικών, κεντρική διαχείριση εγγράφων και συνεργασία ομάδας, για συμβούλους επιχειρήσεων, λογιστές και επιχειρήσεις.",
      en: "A web application for managing funding applications — ESPA, OAED and the Greek Development Law — with automated document checks, centralised document management and team collaboration, built for business consultants, accountants and enterprises.",
    },
    tags: ["Web Application", "SaaS", "Automation", "GDPR"],
    services: {
      gr: ["Σχεδιασμός & ανάπτυξη web application", "Διαχείριση εγγράφων & ροές εργασίας", "Λογαριασμοί χρηστών & συνδρομές"],
      en: ["Web application design & development", "Document management & workflows", "User accounts & subscriptions"],
    },
  },
  {
    slug: "qals",
    name: "QALS.GR",
    url: "https://qals.gr",
    img: "/projects/qals.jpg",
    filter: "websites",
    category: { gr: "ΕΤΑΙΡΙΚΗ ΙΣΤΟΣΕΛΙΔΑ — GR/EN", en: "CORPORATE WEBSITE — GR/EN" },
    desc: {
      gr: "Δίγλωσση εταιρική ιστοσελίδα (Ελληνικά / Αγγλικά) για τη Χατζηανδρέου — μεταλλικές κατασκευές και συστήματα αλουμινίου — με παρουσίαση προϊόντων και εταιρικού προφίλ για αρχιτέκτονες, ιδιώτες και επαγγελματίες.",
      en: "A bilingual (Greek / English) corporate website for Chatziandreou — metal constructions and aluminium systems — presenting products and company profile to architects, homeowners and professionals.",
    },
    tags: ["Website", "GR/EN", "B2B", "Corporate"],
    services: {
      gr: ["Σχεδιασμός & ανάπτυξη εταιρικής ιστοσελίδας", "Δίγλωσση δομή GR/EN", "Παρουσίαση προϊόντων & συστημάτων"],
      en: ["Corporate website design & development", "Bilingual GR/EN structure", "Product & systems presentation"],
    },
  },
  {
    slug: "blouzes4all",
    name: "BLOUZES4ALL.GR",
    url: "https://blouzes4all.gr",
    img: "/projects/blouzes4all.jpg",
    filter: "ecommerce",
    category: { gr: "E-COMMERCE", en: "E-COMMERCE" },
    desc: {
      gr: "Ηλεκτρονικό κατάστημα streetwear με πρωτότυπα σχέδια εμπνευσμένα από την ελληνική μυθολογία — made in Greece, print on demand — με παραγγελία απευθείας μέσω email.",
      en: "A streetwear e-commerce store with original designs inspired by Greek mythology — made in Greece, printed on demand — with ordering directly via email.",
    },
    tags: ["E-commerce", "Brand", "Design"],
    services: {
      gr: ["Σχεδιασμός & ανάπτυξη e-commerce", "Κατάλογος προϊόντων & συλλογές", "Ροή παραγγελίας μέσω email"],
      en: ["E-commerce design & development", "Product catalogue & collections", "Email-based ordering flow"],
    },
  },
  {
    slug: "noeticalab",
    name: "NOETICALAB.GR",
    url: "https://noeticalab.gr",
    img: "/projects/noeticalab.jpg",
    filter: "websites",
    category: { gr: "ΙΣΤΟΣΕΛΙΔΑ / DIGITAL PLATFORM", en: "WEBSITE / DIGITAL PLATFORM" },
    desc: {
      gr: "Ψηφιακή πλατφόρμα για εκδόσεις, ψηφιακά εργαλεία και σεμινάρια γύρω από την επικοινωνία, τη γνωστική ενδυνάμωση και την εκπαίδευση — με άρθρα και online εκπαιδευτικό περιεχόμενο.",
      en: "A digital platform for publications, digital tools and seminars on communication, cognitive empowerment and education — with articles and online educational content.",
    },
    tags: ["Website", "Digital Platform", "Content"],
    services: {
      gr: ["Σχεδιασμός & ανάπτυξη ιστοσελίδας", "Παρουσίαση εκδόσεων & εργαλείων", "Blog / άρθρα & cookie consent"],
      en: ["Website design & development", "Publications & tools showcase", "Blog / articles & cookie consent"],
    },
  },
];

export const projectFilters = [
  { id: "all", label: { gr: "Όλα", en: "All" } },
  { id: "webapps", label: { gr: "Web Applications", en: "Web Applications" } },
  { id: "websites", label: { gr: "Websites", en: "Websites" } },
  { id: "ecommerce", label: { gr: "E-commerce", en: "E-commerce" } },
];
